<template>
  <div class="ms-auto flex max-w-2xl justify-end gap-x-2 sm:gap-x-4">
    <div class="grow space-y-3 text-end">
      <div
        class="chat-bubble inline-block rounded-lg border border-purple-200 bg-purple-100 p-4 text-left shadow-sm"
      >
        <p class="text-sm text-gray-800">
          {{ message.content }}
        </p>
      </div>
    </div>
    <UserAvatar
      v-if="user"
      :user="user"
    />
  </div>
</template>

<script setup lang="ts">
  import type {
    AIChatSessionMessage,
    CustomerCase,
    CustomerOrganisationUser
  } from '@/types/generated'
  import { computed, inject, ref, type Ref } from 'vue'
  import UserAvatar from '@/components/app/users/UserAvatar.vue'

  const props = defineProps<{
    message: AIChatSessionMessage
  }>()

  const caseData = inject<Ref<CustomerCase | null>>('caseData', ref(null))
  const user = computed<CustomerOrganisationUser | null>(() => {
    return caseData.value?.org.users.find((user) => user.uuid === props.message.user_uuid) || null
  })
</script>
